import * as React from 'react';

import type {FromDomainStatus} from 'nutshell-graphql-types';

import {useCheckDomain} from './graphql/hooks/use-check-domain';
import {GroupTableStatus} from './group-table-status';

import styles from './domain-details.module.css';

type Props = {
    domainName: string;
    title: string;
    status: FromDomainStatus;
};

export function TableTitle(props: Props) {
    const {checkDomain} = useCheckDomain();
    const onCheckDomain = () => checkDomain({name: props.domainName});

    return (
        <div className={styles['table-title']}>
            <div>{props.title}</div>
            <GroupTableStatus status={props.status} onRetry={onCheckDomain} />
        </div>
    );
}
